import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Segment } from 'semantic-ui-react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../app/stores/store';
import { useTranslation } from 'react-i18next';
import LoadingComponent from '../../app/layout/LoadingComponent';
import TournamentMatchModal from './TournamentMatchModal';

export default observer(function TournamentMatchPage() {
  const { id } = useParams<{ id: string }>();
  const { tournamentStore } = useStore();
  const { t } = useTranslation();

  useEffect(() => {
    if (id) tournamentStore.loadMatch(id);
    // Also load the parent tournament so we have permission flags
    return () => tournamentStore.clearSelectedMatch();
  }, [id]);

  const match = tournamentStore.selectedMatch;
  const tournament = tournamentStore.selectedTournament;

  if (tournamentStore.loadingInitial || !match)
    return <LoadingComponent content={t('tournament.loading')} />;

  // If navigated directly (no tournament loaded), load it
  if (!tournament && match.tournamentId) {
    tournamentStore.loadTournament(match.tournamentId);
    return <LoadingComponent content={t('tournament.loading')} />;
  }

  if (!tournament) return <LoadingComponent content={t('tournament.loading')} />;

  return (
    <Grid stackable>
      <Grid.Column width={16}>
        <Segment>
          {/* Inline the modal content as a page — reuse TournamentMatchModal but without modal wrapper */}
          <TournamentMatchModal
            match={match}
            tournament={tournament}
            onClose={() => window.history.back()}
          />
        </Segment>
      </Grid.Column>
    </Grid>
  );
});